module.exports = __webpack_public_path__ + "img/service_intro_02@2x.9632aca8.png";